import { render, staticRenderFns } from "./UploadComponent.vue?vue&type=template&id=6b219243"
import script from "./UploadComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadComponent.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports